<template>
  <b-container fluid style="width:1750px">
    <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>

      <b-row class="py-3">
        <b-col>
          <h2>Order Overview Report</h2>
        </b-col>
      </b-row>

      <b-row class="py-2">
        <b-col cols="2">Date From</b-col>
        <b-col cols="2">Date To</b-col>
        <b-col cols="1">Cust Name</b-col>
        <b-col cols="1">Cust Phone</b-col>
        <b-col cols="2">Cust Email</b-col>
        <b-col cols="2">Item</b-col>
        <b-col cols="1">Staff Name</b-col>
      </b-row>
      <b-row class="py-2">
        <b-col cols="2"><b-form-datepicker v-model="datefrom"></b-form-datepicker></b-col>
        <b-col cols="2"><b-form-datepicker v-model="dateto"></b-form-datepicker></b-col>
        <b-col cols="1"><b-form-input v-model="cusname"></b-form-input></b-col>
        <b-col cols="1"><b-form-input v-model="cusphone"></b-form-input></b-col>
        <b-col cols="2"><b-form-input v-model="cusemail"></b-form-input></b-col>
        <b-col cols="2">
          <b-dropdown id="dropdown-items" text="Select Item(s)" ref="item-dropdown" variant="light" no-flip>
            <b-dropdown-form>
              <b-form-checkbox-group
                v-model="itemselect"
                :options="items"
                text-field="name"
                value-field="id"
                stacked
              ></b-form-checkbox-group>
            </b-dropdown-form>
          </b-dropdown>
        </b-col>
        <b-col cols="1">
          <b-dropdown id="dropdown-staff" text="Select Staff" ref="staff-dropdown" variant="light" no-flip>
            <b-dropdown-form>
              <b-form-checkbox-group
                v-model="staffselect"
                :options="staff"
                text-field="name"
                value-field="id"
                stacked
              ></b-form-checkbox-group>
            </b-dropdown-form>
          </b-dropdown>
        </b-col>
      </b-row>
      <b-row class="py-2">
        <b-col cols="1"><b-button variant="light" @click="clearFilters">Clear</b-button></b-col>
        <b-col cols="1"><b-button variant="dark" @click="runOrderOverview()">Run Report</b-button></b-col>
        <b-col cols="1"><b-form-checkbox v-model="csv">Download CSV?</b-form-checkbox></b-col>
      </b-row>
      <b-alert v-if="dateAlert" show>Please choose dates to and from</b-alert>

      <b-table
       striped
       hover
       :items="results"
       :fields="fields"
      >
        <template #cell(time_taken)="data">
          {{ data.item.time_taken | toUSDateFormat(true) }}
        </template>

        <template #cell(pickup_time)="data">
          {{ data.item.pickup_time | toUSDateFormat }}
        </template>

        <template #cell(customer_phone)="data">
          {{ data.item.customer_phone | toUSPhoneNumber }}
        </template>

        <template #cell(staff_name)="data">
          {{ data.item.staff_first_name + ' ' + data.item.staff_last_name }}
        </template>

        <template #cell(subtotal)="data">
          {{ data.item.subtotal | toCurrency }}
        </template>

        <template #cell(discount)="data">
          {{ data.item.discount | toCurrency }}
        </template>

        <template #cell(surcharge)="data">
          {{ data.item.surcharge | toCurrency }}
        </template>

        <template #cell(tip)="data">
          {{ data.item.tip | toCurrency }}
        </template>

        <template #cell(tax)="data">
          {{ data.item.tax | toCurrency }}
        </template>

        <template #cell(total)="data">
          {{ data.item.total | toCurrency }}
        </template>
      </b-table>
      <b-row>
        <b-col>
          Number of orders: {{ total_orders }}
        </b-col>
        <b-col>
          Average Order: {{ avg_order_amount| toCurrency }}
        </b-col>
        <b-col>
          Total Order Amount: {{ total_order_amount | toCurrency }}
        </b-col>
        <b-col>
          Total Tips: {{ total_tips | toCurrency }}
        </b-col>
        <b-col>
          Total Tax: {{ total_tax | toCurrency }}
        </b-col>
      </b-row>

      <b-pagination v-model="currentPage" :total-rows="total_orders" :per-page="limit" align="center" @change="changePage()"></b-pagination>
      <p style="text-align: center;">Total orders returned: {{ total_orders }}</p>
    </b-overlay>
  </b-container>
</template>


<script>
export default {
  name: "OrderOverview",
  data() {
    return {
      results: [],
      items: [],
      staff: [],
      limit: 50,
      currentPage: 1,
      showoverlay: false,
      datefrom: '',
      dateto: '',
      cusname: '',
      cusphone: '',
      cusemail: '',
      total_orders: 0,
      total_order_amount: 0,
      avg_order_amount: 0,
      total_tips: 0,
      total_tax: 0,
      sortparams: '',
      fields: [
          'order_number',
          'time_taken',
          'pickup_time',
          'customer_name',
          'customer_phone',
          'customer_email',
          'staff_name',
          'subtotal',
          'discount',
          'surcharge',
          'tip',
          'tax',
          'total',
          'notes'
      ],
      dateAlert: false,
      itemselect: [],
      staffselect: [],
      csv: false
    };
  },

  computed: {
    datefromfilter: function() {
      return '&datefrom=gte:'+this.datefrom;
    },

    datetofilter: function() {
      return '&dateto=lte:'+this.dateto;
    },

    cusnamefilter: function() {
      if (this.cusname) {
        return '&cusname=like:'+this.cusname;
      } else {
        return '';
      }
    },

    cusphonefilter: function() {
      if (this.cusphone) {
        return '&cusphone=like:'+this.cusphone;
      } else {
        return '';
      }
    },

    cusemailfilter: function() {
      if (this.cusemail) {
        return '&cusemail=like:'+this.cusemail;
      } else {
        return '';
      }
    },

    itemfilter: function() {
      if (this.itemselect.length>0) {
        return '&item=in:'+this.itemselect.join(",");
      } else {
        return '';
      }
    },

    stafffilter: function() {
      if (this.staffselect.length>0) {
        return '&staff=in:'+this.staffselect.join(",");
      } else {
        return '';
      }
    },

    csvfilter: function() {
      if (this.csv==true) {
        return '&csv=True';
      } else {
        return '';
      }
    },

    // sortparams: function() {
    //   if (sortparam=='') {
    //     return '';
    //   } else {
    //     var sortdir = (sortbydesc === true) ? '-' : '+';
    //     return '&sortby=' + sortdir + sortparam;
    //   }
    // },

    // all pagination, filtering and sorting info collected here for housekeeping purposes
    urlext: function() {
      return "?page="+this.currentPage
        +"&limit="+this.limit
        +this.datefromfilter
        +this.datetofilter
        +this.cusnamefilter
        +this.cusphonefilter
        +this.cusemailfilter
        +this.itemfilter
        +this.stafffilter
        +this.csvfilter
        +this.sortparams;
    }

  },

  methods: {
    validateParams() {
      if (!this.datefrom || !this.dateto) {
        this.dateAlert = true;
        return false;
      }
    },

    async runOrderOverview() {
      if (this.validateParams() == false) {
        return;
      }
      const resptype = this.csv==false ? 'json' : 'blob';
      this.showoverlay = true;
      const token = await this.$auth.getTokenSilently();
      const { data } = await this.$api.get("reports/order-overview"+this.urlext, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        },
        responseType: resptype
      });
      if (resptype=='json') {
        this.results = data.order_overview;
        this.results = await this.cleanNullValues(this.results);
        this.total_orders = data.total_orders;
        this.total_order_amount = data.total_order_amount;
        this.avg_order_amount = data.avg_order_amount;
        this.total_tips = data.total_tips;
        this.total_tax = data.total_tax;
      } else {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'order_overview.csv');
        document.body.appendChild(link);
        link.click();
      }
      this.showoverlay = false;
    },

    cleanNullValues(res) {
      res.map(r=>{
        if (r.customer_email===null) {
          r.customer_email="";
        }
        if (r.customer_phone===null) {
          r.customer_phone="";
        }
      })
      return res;
    },

    async fetchItems() {
      this.showoverlay = true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("items?limit=999", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.items = await data.items;
      this.showoverlay = false;
    },

    async fetchUsers() {
      this.showoverlay = true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("users", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.staff = await data.users;
      this.staff.map(s=>s.name=s.first_name + ' ' + s.last_name);
      this.showoverlay = false;
    },

    changePage() {
      this.showoverlay = true;
      this.runOrderOverview();
    },

    clearFilters() {
      this.datefrom = '';
      this.dateto = '';
      this.cusname = '';
      this.cusphone = '';
      this.cusemail = '';
      this.itemselect = [];
      this.staffselect = [];
    },

    // updateSortParams(sortparam, sortbydesc) {
    //   if (sortparam=='') {
    //     this.sortparams='';
    //   } else {
    //     var sortdir = (sortbydesc === true) ? '-' : '+';
    //     this.sortparams = '&sortby=' + sortdir + sortparam;
    //   }
    //   this.showoverlay = true;
    //   this.fetchTransactions();
    // },
  },

  created: function() {
    this.fetchItems();
    this.fetchUsers();
  }

};
</script>
<style>
  .overspin .spinner-border {
    visibility: hidden;
  }

</style>
